<template>
  <div v-loading="loading" element-loading-text="拼命上传中">
    <el-dialog :title="'自动生成印章'" :visible.sync="isShow">
      <el-form :model="operateForm" :rules="rules" ref="operateForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="印章内容" prop="content">
          <el-input v-model="operateForm.content" :readonly="false"></el-input>
        </el-form-item>
        <el-form-item label="印章名称" prop="remark">
          <el-input v-model="operateForm.remark" :readonly="false"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="confirmAutoSeal('operateForm')">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'编辑印章'" :visible.sync="isEditShow">
      <el-form :model="operateEditForm" :rules="rulesEdit" ref="operateEditForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="印章ID" prop="signatureId" hidden="true">
          <el-input v-model="operateEditForm.signatureId" :readonly="false"></el-input>
        </el-form-item>
        <el-form-item label="印章名称" prop="remark">
          <el-input v-model="operateEditForm.remark" :readonly="false"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isEditShow = false">取 消</el-button>
        <el-button type="primary" @click="confirmEditSeal('operateEditForm')">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'上传印章'" :visible.sync="isUploadShow">
      <el-form :model="operateUploadForm" :rules="rulesEdit" ref="operateUploadForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="印章名称" prop="remark">
          <el-input v-model="operateUploadForm.remark" :readonly="false"></el-input>
        </el-form-item>
      </el-form>
      <el-upload
        ref="upload"
        :auto-upload="false"
        :file-list="fileList"
        :multiple="false"
        :limit="1"
        :on-exceed="handleExceed"
        :http-request="uploadFiles"
        accept="image/png"
        action=" "
      >
        <el-button slot="trigger" size="mini" type="primary" style="margin-left: 320px">点击上传</el-button>
        <el-button @click="confirmUpload('operateUploadForm')" size="mini" type="primary" style="margin-left: 20px">确认上传</el-button>
        <div slot="tip" class="el-upload__tip">请上传png格式图片文件,大小不超过150k</div>
        <span> &nbsp; </span>
      </el-upload>
    </el-dialog>
    <el-dialog
      :title="'印章授权'"
      :visible.sync="isSealTransferShow"
      width="900px"
      height="950px"
      top="7vh"
      class="matrix-dialog"
      :lock-scroll="false"
      :before-close="cancelAdd"
      :close-on-click-modal="false"
      v-loading="loadingTable"
    >
      <div>
        <el-row class="componentSelection">
          <el-col :span="24">
            <div class="part-search-input">
              <el-input v-model.trim="materialCode" :placeholder="'关键字'" @keyup.native="matrixSearch">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <span class="ml20">待授权</span>
            <el-table
              header-row-class-name="transfer-table-content"
              ref="multipleLeftTable"
              class="hasBorder"
              cell-class-name="transfer-table-cell"
              :row-class-name="tableRowStripe"
              highlight-current-row
              :data="leftDataRow"
              border
              style="width: 360px"
              height="350px"
              element-loading-spinner="vo-mask"
              element-loading-background="rgba(204,204,204,.5)"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column type="index" width="50"></el-table-column>
              <el-table-column prop="username" :label="'账号'" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column prop="personName" :label="'姓名'" width="150" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-col>
          <el-col :span="4" class="transfer-btn">
            <el-button type="primary" icon="el-icon-d-arrow-right" style="margin-left: 40px; margin-top: 140px" @click="confirmLeftBtn"></el-button>
            <el-button type="primary" icon="el-icon-d-arrow-left" style="margin-left: 40px; margin-top: 10px" @click="confirmRightBtn"></el-button>
          </el-col>
          <el-col :span="10">
            <span class="ml20">已授权</span>
            <el-table
              header-row-class-name="transfer-table-content"
              cell-class-name="transfer-table-cell"
              :row-class-name="checkTableRowStripe"
              ref="multipleRightTable"
              class="hasBorder"
              border
              highlight-current-row
              :data="rightDataRow"
              style="width: 355px"
              height="350px"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column type="index" width="50"></el-table-column>
              <el-table-column prop="username" :label="'账号'" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column prop="personName" :label="'姓名'" width="150" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-button @click="handSealUpload" size="mini" type="primary">上传印章</el-button>
    <el-button @click="autoSealUpload" size="mini" type="primary">自动生成印章</el-button>
    <!-- <img width="180px" height="180px" :src="uploadFiles" alt="图片未上传" /> -->
    <div class="demo-image">
      <el-col :span="6" v-for="item in sealList" :key="item.signature_id" class="pailie">
        <el-image style="width: 150px; height: 150px; margin-left: 80px" :src="'data:image/png;base64,' + item.signature_img_base64">
          <div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div>
        </el-image>
        <div style="text-align: center;margin:auto">
          <span class="demonstration">{{ item.remark }}</span>
        </div>
        <div style="text-align: center;margin:auto;margin-top:5px">
          <i class="el-icon-delete" style="cursor:pointer" @click="delSeal(item.signature_id)">删除</i>
          <i class="el-icon-edit" style="cursor:pointer;margin-left:5px" @click="editSeal(item)">编辑</i>
          <i class="el-icon-coordinate" style="cursor:pointer;margin-left:5px" @click="handleSealPri(item)">授权</i>
        </div>
      </el-col>
    </div>

    <!-- <el-row class="demo-image">
      <el-col :span="8" v-for="item in sealList" :key="item.signature_id" class="pailie">
        <img :src="'data:image/png;base64,' + item.signature_img_base64" width="150px" height="150px" alt="图片未上传" />
        
        <i class="el-icon-delete" @click="delSeal(item.signature_id)"></i>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
import { getAllSealApi } from '../../api/getData'
import { uploadSealApi } from '../../api/getData'
import { delSealApi } from '../../api/getData'
import { autoSealApi } from '../../api/getData'
import { editSealApi } from '../../api/getData'
import { pageSealPriInfoApi } from '../../api/getData'
import { saveSealPriApi } from '../../api/getData'

export default {
  data() {
    return {
      imgFile: '',
      loading: false,
      isShow: false,
      isEditShow: false,
      isUploadShow: false,
      currentUser: '',
      signatureId: '',
      //--------穿梭框
      isSealTransferShow: false,
      materialCode: '',
      loadingTable: false,
      leftDataRow: [],
      rightDataRow: [],
      //----------穿梭框
      file: {},
      fileList: [],
      operateForm: {
        cUser: '',
        content: '',
        remark: ''
      },
      rules: {
        content: [{ required: true, message: '请填写印章内容', trigger: 'blur' }],
        remark: [{ required: true, message: '请填写印章名称', trigger: 'blur' }]
      },
      operateFormLabel: [
        {
          model: 'cUser',
          label: '当前用户',
          prop: 'cUser',
          readonly: true
        },
        {
          model: 'content',
          prop: 'content',
          label: '印章内容',
          readonly: false
        },
        {
          model: 'remark',
          prop: 'remark',
          label: '印章名称',
          readonly: false
        }
      ],
      operateEditForm: {
        signatureId: '',
        remark: ''
      },
      rulesEdit: {
        remark: [{ required: true, message: '请填写印章名称', trigger: 'blur' }]
      },
      operateEditFormLabel: [
        {
          model: 'signatureId',
          label: '印章ID',
          prop: 'signatureId',
          readonly: true
        },
        {
          model: 'remark',
          prop: 'remark',
          label: '印章名称',
          readonly: false
        }
      ],
      operateUploadForm: {
        remark: ''
      },
      operateUploadFormLabel: [
        {
          model: 'remark',
          prop: 'remark',
          label: '印章名称',
          readonly: false
        }
      ],
      sealList: [
        {
          signature_id: '',
          signature_img_base64: '',
          signature_type: ''
        }
      ]
    }
  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },

    confirmUpload(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$confirm('请确认上传的印章图片背景为透明的，否则盖章时印章会遮挡合同正文，是否继续上传? 如果不上传印章，系统会使用默认印章样式', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '重新上传',
            type: 'warning'
          })
            .then(() => {
              this.isUploadShow = false
              this.uploadFiles(this.operateUploadForm.remark)
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '请重新上传图片'
              })
            })
        } else {
          this.$message({
            type: 'warning',
            message: '填写信息有误，请检查!'
          })
          return false
        }
      })
    },
    autoSealUpload() {
      this.isShow = true
    },
    confirmAutoSeal(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //调用自动生成印章api
          autoSealApi(this.operateForm.remark, this.operateForm.content).then(res => {
            res = res.data
            if (res.code == 0) {
              this.$router.go(0)
              this.isShow = false
            } else {
              this.$message({
                type: 'warning',
                message: res.msg + '当前用户无权限访问'
              })
            }
          })
        } else {
          this.$message({
            type: 'warning',
            message: '填写信息有误，请检查!'
          })
          return false
        }
      })
    },
    //点击上传图片,上传成功返回图片路径
    uploadFiles(remark) {
      console.info('开始上传')
      this.loading = true
      let file = this.$refs.upload.$refs['upload-inner'].$refs.input //获取文件数据
      let fileList = file.files
      var that = this
      console.info(fileList)
      if (fileList.length == 0) {
        alert('上传失败，未获取到印章文件')
        that.loading = false
        return
      }
      var imgFile
      let reader = new FileReader() //html5读文件
      reader.readAsDataURL(fileList[0]) //转BASE64
      reader.onload = function(e) {
        imgFile = e.target.result
        //imgFile = '../../assets/images/user.png'
        console.info(imgFile)
        //读取完毕后调用fdd上传接口
        uploadSealApi(imgFile, remark).then(res => {
          res = res.data
          console.info(res)
          if (res.code == 1) {
            alert('印章上传成功')
            that.$router.go(0)
          } else {
            that.$message({
              type: 'warning',
              message: '印章上传失败,' + res.msg
            })
          }
          that.loading = false
        })
      }
    },

    //获取所有印章图片
    getAllSealList() {
      getAllSealApi().then(res => {
        res = res.data
        if (res.code == 1) {
          this.sealList = res.data
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      })
    },
    //删除印章
    delSeal(id) {
      this.$confirm('此操作将删除该印章, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delSealApi(id).then(res => {
            console.info(res.data)
            if (res.data.code == 1) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.$router.go(0)
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //编辑印章
    editSeal(item) {
      this.isEditShow = true
      this.operateEditForm.signatureId = item.signature_id
      this.operateEditForm.remark = item.remark
    },
    confirmEditSeal(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //编辑印章api
          editSealApi(this.operateEditForm.remark, this.operateEditForm.signatureId).then(res => {
            res = res.data
            if (res.code == 0) {
              this.$router.go(0)
              this.isEditShow = false
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        } else {
          this.$message({
            type: 'warning',
            message: '填写信息有误，请检查!'
          })
          return false
        }
      })
    },
    handSealUpload() {
      this.isUploadShow = true
    },
    handleSealPri(item) {
      this.isSealTransferShow = true
      this.signatureId = item.signature_id
      this.getSealPriList()
    },
    getSealPriList() {
      var type = 'leftData'
      pageSealPriInfoApi(this.signatureId, this.currentUser, type).then(res => {
        this.leftDataRow = res.data
      })
      type = 'rightData'
      pageSealPriInfoApi(this.signatureId, this.currentUser, type).then(res => {
        this.rightDataRow = res.data
      })
    },
    //取消
    cancelAdd() {
      this.isSealTransferShow = false
    },
    tableRowStripe({ row, rowIndex }) {
      if (row.checkDisabled) {
        return 'check-blue'
      }
      if (rowIndex % 2 == 1) {
        return 'color-gray'
      }
      return ''
    },
    checkTableRowStripe({ rowIndex }) {
      if (rowIndex % 2 == 1) {
        return 'color-gray'
      }
      return ''
    },
    confirmLeftBtn() {
      var leftSelects = this.$refs.multipleLeftTable.selection
      if (leftSelects.length == 0) {
        this.$message({
          type: 'warning',
          message: '请勾选【待选择】列表数据!'
        })
      } else {
        this.loadingTable = true
        saveSealPriApi(this.signatureId, this.currentUser, 'leftData', leftSelects).then(res => {
          res = res.data
          if (res.code == 0) {
            this.getSealPriList()
            this.$message({
              type: 'info',
              message: '保存成功'
            })
          } else {
            this.$message({
              type: 'warning',
              message: '操作失败'
            })
          }
          this.loadingTable = false
        })
      }
    },
    confirmRightBtn() {
      var rightSelects = this.$refs.multipleRightTable.selection
      if (rightSelects.length == 0) {
        this.$message({
          type: 'warning',
          message: '请勾选【已选择】列表数据!'
        })
      } else {
        this.loadingTable = true
        saveSealPriApi(this.signatureId, this.currentUser, 'rightData', rightSelects).then(res => {
          res = res.data
          if (res.code == 0) {
            this.getSealPriList()
            this.$message({
              type: 'info',
              message: '保存成功'
            })
          } else {
            this.$message({
              type: 'warning',
              message: '操作失败'
            })
          }
          this.loadingTable = false
        })
      }
    }
  },
  created() {
    this.currentUser = window.localStorage.getItem('mobile')
    this.getAllSealList()
  }
}
</script>

<style lang="scss" scoped>
.matrix-dialog {
  .el-dialog {
    max-height: 660px;
  }
  .el-dialog__body {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .componentSelection {
    margin-bottom: 20px;
    .part-search-input {
      display: inline-block;
      width: 400px;
      .el-input__prefix {
        left: 7px;
      }
      .el-input__inner {
        border-radius: 15px;
        background-color: #f7f9fe;
        padding-left: 33px;
        font-size: 14px;
      }
    }
    .ml20 {
      margin-left: 40px;
    }
  }
  .el-dialog__footer {
    padding: 15px 40px;
  }
}
</style>
